import { Component, Input, ViewChild } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'app-copy-to-clipboard-button',
    templateUrl: './copy-to-clipboard-button.component.html',
    styleUrls: ['./copy-to-clipboard-button.component.scss']
})
export class CopyToClipboardButtonComponent {
    @Input() textToCopy: {
        text: string;
        html?: string;
    };
    @Input() elementToCopy: HTMLElement;
    @Input() elementToCopySanitizerFunc: (el: HTMLElement) => HTMLElement;
    @Input() iconOnly = false;
    @ViewChild('tooltipCopy') tooltipCopy: MatTooltip;
    tooltipCopyTimerBeforeAutoHide: any;

    async onCopyToClipboard() {
        if (this.elementToCopy) {
            await this.copyHtmlElementToClipboard();
        } else {
            const clipboardItem = new ClipboardItem({
                'text/html': new Blob([this.textToCopy.html || this.textToCopy.text], {
                    type: 'text/html'
                }),
                'text/plain': new Blob([this.textToCopy.text], { type: 'text/plain' })
            });
            try {
                await navigator.clipboard.write([clipboardItem]);
                this.tooltipCopy.show();
            } catch (err) {
                console.error('Erreur de copie :', err);
            }
        }
        clearTimeout(this.tooltipCopyTimerBeforeAutoHide);
        this.tooltipCopyTimerBeforeAutoHide = setTimeout(() => {
            this.tooltipCopy.hide();
        }, 2000);
    }

    async copyHtmlElementToClipboard() {
        const cloneElementToCopy = this.cloneAndRedesignElementToCopy(this.elementToCopy);
        const html = cloneElementToCopy.innerHTML;
        const text = cloneElementToCopy.innerText || cloneElementToCopy.textContent;

        const clipboardItem = new ClipboardItem({
            'text/html': new Blob([html], { type: 'text/html' }),
            'text/plain': new Blob([text], { type: 'text/plain' })
        });
        try {
            await navigator.clipboard.write([clipboardItem]);
            this.tooltipCopy.show();
        } catch (err) {
            console.error('Erreur de copie :', err);
        }
    }

    cloneAndRedesignElementToCopy(elementToCopy: HTMLElement): HTMLElement {
        let cloneElementToCopy = elementToCopy.cloneNode(true) as HTMLElement;
        if (this.elementToCopySanitizerFunc) {
            cloneElementToCopy = this.elementToCopySanitizerFunc(cloneElementToCopy);
        }
        cloneElementToCopy.querySelectorAll('table').forEach(element => {
            element.style.border = '1px solid black';
            element.style.borderCollapse = 'collapse';
            element.querySelectorAll('td, th').forEach((element: HTMLElement) => {
                element.style.border = '1px solid black';
            });
        });

        return cloneElementToCopy;
    }
}
